if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"product-doorway-ui","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^webpack_sharing_consume_default_react(_react\-_(8284|cd2a)|\-dom_react\-dom)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}